import { useEffect } from "react";

export default function Cursor() {
  useEffect(() => {
    if (typeof window === "undefined" || "ontouchstart" in window) return;

    const cursor = document.createElement("div");
    Object.assign(cursor.style, {
      position: "fixed",
      top: "0",
      left: "0",
      width: "22px",
      height: "22px",
      borderRadius: "50%",
      background: "rgba(0, 229, 254, 0.95)",
      pointerEvents: "none",
      zIndex: "2147483647",
      mixBlendMode: "normal",
      transform: "translate3d(-50%, -50%, 0)",
      transition: "background 150ms ease, width 120ms ease, height 120ms ease, box-shadow 150ms ease",
      boxShadow: "0 0 12px rgba(0,229,254,0.6)",
    });
    document.body.appendChild(cursor);

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let currentX = mouseX;
    let currentY = mouseY;
    const speed = 0.25; // 🧠 adjust 0.15–0.35 → higher = faster

    const update = () => {
      // Smoothly interpolate position
      currentX += (mouseX - currentX) * speed;
      currentY += (mouseY - currentY) * speed;

      cursor.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) translate(-50%, -50%)`;
      requestAnimationFrame(update);
    };

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const handleMouseDown = () => {
      cursor.style.transform += " scale(0.8)";
      setTimeout(() => {
        cursor.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) translate(-50%, -50%) scale(1)`;
      }, 150);
    };

    const handleHover = (e) => {
      const el = e.target;
      const interactive = el && el.closest && el.closest("a, button, [role='button'], input, textarea, select, [onclick]");
      if (interactive) {
        cursor.style.background = "rgba(255,255,255,0.95)";
        cursor.style.width = "36px";
        cursor.style.height = "36px";
        cursor.style.boxShadow = "0 0 18px rgba(255,255,255,0.9)";
      } else {
        cursor.style.background = "rgba(0, 229, 254, 0.95)";
        cursor.style.width = "22px";
        cursor.style.height = "22px";
        cursor.style.boxShadow = "0 0 12px rgba(0,229,254,0.6)";
      }
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mousedown", handleMouseDown);
    window.addEventListener("mouseover", handleHover);

    update();

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mousedown", handleMouseDown);
      window.removeEventListener("mouseover", handleHover);
      cursor.remove();
    };
  }, []);

  return null;
}
